import { Fragment, JSX } from "react";

import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import {
  type AttributeHeadlineProps as BaseAttributeHeadlineProps,
  ConfigurationAttributeInfo,
  INFO_LAYOUT_PROPS_DEFAULTS,
} from "@plansoft-configuration-renderer/components";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";
import { useAttributeLayoutBaseProps } from "@plansoft-configuration-renderer/layout";

export type AttributeHeadlineProps = BaseAttributeHeadlineProps;

export function CustomAttributeHeadline(
  props: AttributeHeadlineProps,
): JSX.Element {
  const { infoProps = INFO_LAYOUT_PROPS_DEFAULTS } = props;
  const { custom } = useAttributeLayoutBaseProps();

  const attribute = useCsAttribute();
  const labelText = attribute.name || attribute.id;

  if (custom?.visualStyle === "default") {
    return (
      <Box
        className="attribute-headline"
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <FormLabel
          required={attribute.isRequired}
          disabled={!attribute.isAllowed}
        >
          {labelText}
        </FormLabel>
        <ConfigurationAttributeInfo {...infoProps} />
      </Box>
    );
  }

  return <Fragment />;
}
